
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Attaching additional props | v2`}</h2>
    <p>{`To avoid unnecessary wrappers that just pass on some props to the rendered component, or element, you can use the `}<a parentName="p" {...{
        "href": "/docs/api#attrs"
      }}><inlineCode parentName="a">{`.attrs`}</inlineCode>{` constructor`}</a>{`. It allows you to attach additional props (or "attributes") to a component.`}</p>
    <p>{`This way you can for example attach static props to an element, or pass a third-party prop like `}<inlineCode parentName="p">{`activeClassName`}</inlineCode>{` to React Router's Link component. Furthermore you can also attach more dynamic props to a component. The `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{` object also takes functions, that receive the props that the component receives. The return value will be merged into the resulting props as well.`}</p>
    <p>{`Here we render an `}<inlineCode parentName="p">{`Input`}</inlineCode>{` component and attach some dynamic and static attributes to it:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`const Input = styled.input.attrs(props => ({
  // we can define static props
  type: "text",

  // or we can define dynamic ones
  size: props.size || "1em",
}))\`
  color: palevioletred;
  font-size: 1em;
  border: 2px solid palevioletred;
  border-radius: 3px;

  /* here we use the dynamically computed prop */
  margin: \${props => props.size};
  padding: \${props => props.size};
\`;

render(
  <div>
    <Input placeholder="A small text input" />
    <br />
    <Input placeholder="A bigger text input" size="2em" />
  </div>
);
`}</code></pre>
    <p>{`As you can see, we get access to our newly created props in the interpolations, and the `}<inlineCode parentName="p">{`type`}</inlineCode>{` attribute is passed down to the element.`}</p>
    <h3>{`Overriding .attrs`}</h3>
    <p>{`Notice that when wrapping styled components, `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{` are applied from the innermost styled component to the outermost styled component.`}</p>
    <p>{`This allows each wrapper to `}<strong parentName="p">{`override`}</strong>{` nested uses of `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{`, similarly to how css properties defined later in a stylesheet override previous declarations.`}</p>
    <p><inlineCode parentName="p">{`Input`}</inlineCode>{`'s `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{` are applied first, and then `}<inlineCode parentName="p">{`PasswordInput`}</inlineCode>{`'s `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.size || "1em",
}))\`
  border: 2px solid palevioletred;
  margin: \${props => props.size};
  padding: \${props => props.size};
\`;

// Input's attrs will be applied first, and then this attrs obj
const PasswordInput = styled(Input).attrs({
  type: "password",
})\`
  // similarly, border will override Input's border
  border: 2px solid aqua;
\`;

render(
  <div>
    <Input placeholder="A bigger text input" size="2em" />
    <br />
    {/* Notice we can still use the size attr from Input */}
    <PasswordInput placeholder="A bigger password input" size="2em" />
  </div>
);
`}</code></pre>
    <p>{`This is why `}<inlineCode parentName="p">{`PasswordInput`}</inlineCode>{` is of a password type, but still uses the `}<inlineCode parentName="p">{`size`}</inlineCode>{` attribute from `}<inlineCode parentName="p">{`Input`}</inlineCode>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;